import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface RestaurantData {
  restaurant_id: string;
  restaurant_name: string;
  logo: string | null;
  owner: string;
  phone: string;
  restaurant_address: string;
  state: string;
  country: string;
  zipcode: string;
  cusine_type: string;
  description: string;
}

interface RestaurantState {
  data: RestaurantData | null;
  loading: boolean;
  error: string | null;
}

const initialState: RestaurantState = {
  data: null,
  loading: false,
  error: null,
};

const restaurantSlice = createSlice({
  name: 'restaurant',
  initialState,
  reducers: {
    fetchRestaurantRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchRestaurantSuccess: (state, action: PayloadAction<RestaurantData>) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    fetchRestaurantFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchRestaurantRequest,
  fetchRestaurantSuccess,
  fetchRestaurantFailure,
} = restaurantSlice.actions;

export default restaurantSlice.reducer;
